import {
  AppShell,
  Box,
  Burger,
  Button,
  Collapse,
  createStyles,
  Group,
  MediaQuery,
  Navbar,
  ScrollArea,
  Text,
  UnstyledButton,
  useMantineTheme,
  Container,
  Image,
  LoadingOverlay,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { Route } from "react-router-dom"; // Additionally installed package
import PropTypes from "prop-types";
import { ModalsProvider } from "@mantine/modals";
import {
  HomeIcon,
  DashboardIcon,
  PersonIcon,
  QuestionMarkIcon,
  FileIcon,
  Pencil2Icon,
  GearIcon,
  RocketIcon,
} from "@modulz/radix-icons";
import ThemeButton from "../Components/ThemeButton";
import { Announcements } from "../Components/Dashboard-Components/Announcements";
import { Mentors } from "../Components/Dashboard-Components/Mentors";
import { WaGroups } from "../Components/Dashboard-Components/WaGroups";
import { Tasks } from "./Tasks";
import { Faq } from "../Components/FAQ-Components/Faq";
import TaskPage from "./taskpage";

import Submission from "./../Components/Grade-Component/Submission";
import { Profile } from "../Components/Profile-Component/Profile";
// import { NavbarComp } from "../Components/Authentications-Components/Navbar";
import Toast from "./../Components/Toast";
import { fetchUserApi } from "../api/user";
import Settings from "./Settings";
import MissionControl from "./MissionControl";
import Results from "../Components/Results-Component/Results";

const isMentee = localStorage.getItem("type") == "MENTEE" ? true : false;
const isMentor = localStorage.getItem("type") == "MENTOR" ? true : false;
const isAdmin = localStorage.getItem("type") == "ADMIN" ? true : false;

async function fetchUser() {
  const res = await fetchUserApi().catch((err) => {
    Toast(
      "ERROR",
      err.response != null
        ? err.response.data != null
          ? err.response.data.message != null
            ? err.response.data.message
            : err.message
          : err.message
        : err.message,
      "red"
    );
    if (err.response.status == 401 || err.response.status == 403) {
      localStorage.clear();
      window.location.replace("/");
    }
  });
  if (res == null) return;
  if (res.status == 200) {
    localStorage.setItem("userName", res.data.user.name);
    return res.data.user.name;
  } else {
    Toast("ERROR", res.data.message, "red");
    return;
  }
}

const icons = {
  Home: <HomeIcon />,
  Dashboard: <DashboardIcon />,
  Tasks: <Pencil2Icon />,
  Grade: <FileIcon />,
  Submissions: <FileIcon />,
  FAQ: <QuestionMarkIcon />,
  Profile: <PersonIcon />,
  MissionControl: <RocketIcon />,
  Settings: <GearIcon />,
};

const navbarData = [
  { label: "Home", initallyOpened: true, link: "/" },
  {
    label: "Dashboard",
    initiallyOpened: false,
    links: [
      { label: "Announcements", link: "/dashboard/announcements" },
      { label: "People", link: "/dashboard/people" },
      { label: "Whatsapp Links", link: "/dashboard/walink" },
    ],
  },

  { label: "Tasks", initallyOpened: true, link: "/dashboard/tasks" },
  isMentor == true || isAdmin == true
    ? { label: "Grade", initallyOpened: true, link: "/dashboard/grade" }
    : null,
  isMentee == true
    ? {
      label: "Submissions",
      initallyOpened: true,
      link: "/dashboard/submissions",
    }
    : null,
  { label: "FAQ", initallyOpened: true, link: "/dashboard/faq" },
  { label: "Profile", link: "/dashboard/profile" },
  isAdmin == true ? { label: "Settings", link: "/dashboard/settings" } : null,
  isAdmin == true
    ? { label: "MissionControl", link: "/dashboard/missionControl" }
    : null,
].filter(Boolean);

const useStyles = createStyles((theme) => ({
  navbar: {
    backgroundColor:
      theme.colorScheme === "dark" ? theme.colors.blue[2] : theme.white,
    paddingBottom: 0,
  },

  header: {
    padding: theme.spacing.md,
    fontSize: 20,
    paddingTop: 0,
    marginLeft: -theme.spacing.md,
    marginRight: -theme.spacing.md,
    color: theme.colors.gray[0],
    borderBottom: `1px solid ${theme.colorScheme === "dark" ? theme.colors.blue[5] : theme.colors.blue[5]
      }`,
  },

  links: {
    marginLeft: -theme.spacing.md,
    marginRight: -theme.spacing.md,
  },

  linksInner: {
    paddingTop: theme.spacing.xl,
    paddingBottom: theme.spacing.xl,
  },

  footer: {
    marginLeft: -theme.spacing.md,
    marginRight: -theme.spacing.md,
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    borderTop: `1px solid ${theme.colorScheme === "dark" ? theme.colors.blue[5] : theme.colors.blue[5]
      }`,
  },
  control: {
    fontWeight: 500,
    display: "block",
    width: "100%",
    padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,
    color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.white,
    fontSize: theme.fontSizes.sm,

    "&:hover": {
      transition: ".2s ease",
      transform: "scale(1.05)",
    },
  },

  link: {
    fontWeight: 500,
    display: "block",
    textDecoration: "none",
    padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,
    paddingLeft: 31,
    marginLeft: 30,
    fontSize: theme.fontSizes.sm,
    color:
      theme.colorScheme === "dark"
        ? theme.colors.gray[0]
        : theme.colors.gray[0],
    borderLeft: `1px solid ${theme.colorScheme === "dark" ? theme.colors.blue[3] : theme.colors.blue[3]
      }`,

    // "&:hover": {
    //   color: theme.black,
    // },
  },

  chevron: {
    transition: "transform 200ms ease",
  },
}));

function NavbarLinksGroup({ label, initiallyOpened, links, link }) {
  const { classes, theme } = useStyles();
  // console.log(theme);
  const hasLinks = Array.isArray(links);
  const [opened, setOpened] = useState(initiallyOpened || false);

  const items = (hasLinks ? links : []).map((link) => (
    <Text
      component="a"
      className={classes.link}
      href={link.link}
      key={link.label}
      style={{ background: "transparent" }}
    >
      {link.label}
    </Text>
  ));

  return (
    <Box
      sx={(theme) => ({
        minHeight: 22,
        padding: theme.spacing.md,
        background: theme.fn.linearGradient(
          90,
          "#0048B4",
          "#0063F8",
          "#3391FF"
        ),
      })}
    >
      <UnstyledButton
        onClick={() => setOpened((o) => !o)}
        className={classes.control}
        component="a"
        href={hasLinks ? null : link}
      >
        <Group position="apart" spacing={0}>
          <Text
            sx={{
              display: "flex",
              alignItems: "center",
              fontSize: theme.fontSizes.sm,
            }}
          >
            {icons[label]}
            <Box ml="md">{label}</Box>
          </Text>
        </Group>
      </UnstyledButton>
      {hasLinks ? <Collapse in={opened}>{items}</Collapse> : null}
    </Box>
  );
}
NavbarLinksGroup.propTypes = {
  label: PropTypes.string,
  initiallyOpened: PropTypes.bool,
  links: PropTypes.array,
  link: PropTypes.string,
};

export default function Dashboard() {
  const theme = useMantineTheme();
  const [openedNavbar, setOpenedNavbar] = useState(false);
  const [user, setUser] = useState("");
  const [userLoad, setUserLoad] = useState(false);
  const { classes } = useStyles();
  const links = navbarData.map((item) => (
    <NavbarLinksGroup
      label={item.label}
      initiallyOpened={item.initiallyOpened}
      links={item.links}
      key={item.label}
      link={item.link}
    />
  ));
  useEffect(() => {
    // const userName = localStorage.getItem("userName");
    // if (userName != null) setUser(userName);
    // else {
    setUserLoad(true);
    fetchUser().then((res) => {
      setUserLoad(false);
      if (res != null) {
        setUser(res);
      }
    });
    // }
  }, []);
  return (
    <ModalsProvider>
      <AppShell
        navbarOffsetBreakpoint="sm"
        asideOffsetBreakpoint="sm"
        fixed
        padding="md"
        navbar={
          <Navbar
            hidden={!openedNavbar}
            width={{ sm: 235 }}
            p="md"
            hiddenBreakpoint="sm"
            className={classes.navbar}
            style={{
              background: theme.fn.linearGradient(
                90,
                "#0048B4",
                "#0063F8",
                "#3391FF"
              ),
            }}
          >
            <Navbar.Section className={classes.header}>
              <Group position="apart">
                <a href="https://spider.nitt.edu/" target="blank">
                  <Image
                    src="/Spider-Logo.svg"
                    alt="Spider-logo"
                    style={{ width: "40px" }}
                    href="https://spider.nitt.edu/"
                  />
                </a>
                <MediaQuery largerThan="sm" styles={{ display: "none" }}>
                  <Burger
                    opened={openedNavbar}
                    onClick={() => setOpenedNavbar((o) => !o)}
                    size="sm"
                    color={theme.colors.gray[9]}
                    mr="xl"
                  />
                </MediaQuery>
                <Text
                  sx={{ fontWeight: 500 }}
                  style={{
                    fontSize: 20,
                    width: "100%",
                    background: "transparent",
                    color: theme.white,
                  }}
                >
                  <Text style={{ fontSize: 20 }}>Welcome</Text>
                  <LoadingOverlay visible={userLoad} />
                  {user}
                </Text>
              </Group>
            </Navbar.Section>

            <Navbar.Section
              grow
              className={classes.links}
              component={ScrollArea}
              style={{
                background: theme.fn.linearGradient(
                  90,
                  "#0048B4",
                  "#0063F8",
                  "#3391FF"
                ),
                fontSize: 20,
              }}
            >
              <div
                className={classes.linksInner}
                style={{
                  background: theme.fn.linearGradient(
                    90,
                    "#0048B4",
                    "#0063F8",
                    "#3391FF"
                  ),
                  overflowX: "hidden",
                }}
              >
                {links}
              </div>
            </Navbar.Section>
            <Navbar.Section
              className={classes.footer}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "0 1em 0 0em",
              }}
            >
              <ThemeButton />
              <Button
                component="a"
                href={"/"}
                compact
                variant="filled"
                style={{
                  background: "red",
                  fontSize: theme.fontSizes.xs,
                }}
                onClick={() =>
                  localStorage.removeItem("token") &
                  localStorage.removeItem("type") &
                  localStorage.removeItem("id") &
                  localStorage.removeItem("userName") &
                  localStorage.removeItem("roll") &
                  localStorage.removeItem("regToken") &
                  Toast("Logout Sucessfful", "", "green")
                }
              >
                Logout
              </Button>
            </Navbar.Section>
          </Navbar>
        }
        styles={(theme) => ({
          main: {
            backgroundColor:
              theme.colorScheme === "dark"
                ? theme.colors.dark[8]
                : theme.colors.gray[0],
          },
        })}
      >
        <Container
          style={{
            textAlign: "center",
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
            paddingLeft: "0px",
            paddingRight: "0px",
            // paddingBottom: "60px",
            // paddingTop: "30px",
          }}
        >
          <MediaQuery largerThan="sm" styles={{ display: "none" }}>
            <Burger
              opened={openedNavbar}
              onClick={() => setOpenedNavbar((o) => !o)}
              size="sm"
              color={theme.colors.gray[6]}
              mr="xl"
            />
          </MediaQuery>
        </Container>

        <div
          style={{
            textAlign: "center",
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          {/* {!localStorage.getItem("token") && (
            <Route index path="/" element={<NavbarComp links={links} />} />
          )} */}

          <Route path="/dashboard/announcements">
            <Announcements />
          </Route>
          <Route path="/dashboard/people">
            <Mentors />
          </Route>
          <Route path="/dashboard/walink">
            <WaGroups />
          </Route>
          <Route exact path="/dashboard/tasks">
            <Tasks />
          </Route>
          <Route exact path="/dashboard/tasks/:id">
            <TaskPage />
          </Route>
          {isMentor == true || isAdmin == true ? (
            <Route path="/dashboard/grade">
              <Submission />
            </Route>
          ) : null}
          {isMentee == true ? (
            <Route path="/dashboard/submissions">
              <Results />
            </Route>
          ) : null}
          <Route path="/dashboard/faq">
            <Faq />
          </Route>
          <Route path="/dashboard/profile">
            <Profile />
          </Route>
          {isAdmin == true ? (
            <Route path="/dashboard/settings">
              <Settings />
            </Route>
          ) : null}
          {isAdmin == true ? (
            <Route path="/dashboard/missionControl">
              <MissionControl />
            </Route>
          ) : null}
        </div>
      </AppShell>
    </ModalsProvider>
  );
}
